"use strict";

exports.__esModule = true;
exports.observePageClicks = observePageClicks;

var _constants = require("../constants");

function observePageClicks(transactionService) {
  var clickHandler = function clickHandler(event) {
    if (event.target instanceof Element) {
      createUserInteractionTransaction(transactionService, event.target);
    }
  };

  var eventName = 'click';
  var useCapture = true;
  window.addEventListener(eventName, clickHandler, useCapture);
  return function () {
    window.removeEventListener(eventName, clickHandler, useCapture);
  };
}

function createUserInteractionTransaction(transactionService, target) {
  var _getTransactionMetada = getTransactionMetadata(target),
      transactionName = _getTransactionMetada.transactionName,
      context = _getTransactionMetada.context;

  var tr = transactionService.startTransaction("Click - " + transactionName, _constants.USER_INTERACTION, {
    managed: true,
    canReuse: true,
    reuseThreshold: 300
  });

  if (tr && context) {
    tr.addContext(context);
  }
}

function getTransactionMetadata(target) {
  var metadata = {
    transactionName: null,
    context: null
  };
  var tagName = target.tagName.toLowerCase();
  var transactionName = tagName;

  if (!!target.dataset.transactionName) {
    transactionName = target.dataset.transactionName;
  } else {
    var name = target.getAttribute('name');

    if (!!name) {
      transactionName = tagName + "[\"" + name + "\"]";
    }
  }

  metadata.transactionName = transactionName;
  var classes = target.getAttribute('class');

  if (classes) {
    metadata.context = {
      custom: {
        classes: classes
      }
    };
  }

  return metadata;
}


//////////////////
// WEBPACK FOOTER
// ./~/@elastic/apm-rum-core/dist/lib/common/observers/page-clicks.js
// module id = 433
// module chunks = 0